import { __assign, __rest } from "tslib";
import React from 'react';
import { Input, InputContainer, InputLeftElement, InputRightElement, } from '@mercell/input-react';
import { Calendar32, EarthFilled20, Time32 } from '@carbon/icons-react';
import { twMerge } from 'tailwind-merge';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import Tooltip from '@mercell/tooltip-react';
import cx from 'classnames';
var InputElement = function (_a) {
    var showTimeSelectOnly = _a.showTimeSelectOnly, onClick = _a.onClick, disabled = _a.disabled;
    var Element = showTimeSelectOnly ? Time32 : Calendar32;
    return (React.createElement(Element, { onClick: onClick, className: twMerge('cursor-pointer', disabled && 'text-alto pointer-events-none') }));
};
var DateInput = React.forwardRef(function (_a, ref) {
    var value = _a.value, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, disabled = _a.disabled, onClick = _a.onClick, showTimeSelectOnly = _a.showTimeSelectOnly, _b = _a.isClearable, isClearable = _b === void 0 ? false : _b, endDateRange = _a.endDateRange, showTimeSelect = _a.showTimeSelect, dateFormat = _a.dateFormat, locale = _a.locale, selected = _a.selected, startDateRangeFormat = _a.startDateRangeFormat, endDateRangeFormat = _a.endDateRangeFormat, timeZone = _a.timeZone, isValueUTC = _a.isValueUTC, rest = __rest(_a, ["value", "onChange", "onFocus", "placeholder", "disabled", "onClick", "showTimeSelectOnly", "isClearable", "endDateRange", "showTimeSelect", "dateFormat", "locale", "selected", "startDateRangeFormat", "endDateRangeFormat", "timeZone", "isValueUTC"]);
    var startDate;
    var endDate;
    var dateRange;
    if (endDateRange && !showTimeSelect && dateFormat && selected) {
        startDate = format(selected, startDateRangeFormat !== null && startDateRangeFormat !== void 0 ? startDateRangeFormat : 'Pp', {
            locale: locale,
        });
        endDate = format(endDateRange, endDateRangeFormat !== null && endDateRangeFormat !== void 0 ? endDateRangeFormat : 'Pp z', {
            locale: locale,
        });
        dateRange = "".concat(startDate, " - ").concat(endDate);
    }
    if (selected && timeZone && isValueUTC) {
        dateRange = formatInTimeZone(selected, timeZone, !Array.isArray(dateFormat) && dateFormat ? dateFormat : 'Pp z', { locale: locale });
    }
    return (React.createElement(InputContainer, null,
        timeZone && isValueUTC && (React.createElement(InputLeftElement, { className: "flex items-center" },
            React.createElement(Tooltip, { message: timeZone, placement: "right", tooltipMessageClassName: "text-left", className: "ml-2 text-body inline-flex align-top" },
                React.createElement(EarthFilled20, null)))),
        React.createElement(Input, __assign({}, rest, { placeholder: placeholder, onChange: onChange, onFocus: onFocus, value: dateRange || value, type: "text", id: "date-input", className: cx(isClearable ? 'pr-20' : 'pr-12', timeZone && isValueUTC && 'pl-14'), tabIndex: 0, disabled: disabled, ref: ref })),
        React.createElement(InputRightElement, { className: "flex items-center" },
            React.createElement(InputElement, { onClick: onClick, disabled: disabled, showTimeSelectOnly: showTimeSelectOnly }))));
});
export default DateInput;
